<div class="navbar-wrapper fixed-top">
  <app-eca-marquee *ngIf="environmentSetting === 'UAT'"></app-eca-marquee>
  <p-menubar [model]="navItems" styleClass="eca-primary-bg">
    <ng-template pTemplate="start">
      <a class="menubar-brand" href="#">
        <img [src]="'assets/eCOMS_Logo_Edited_White.png'" alt="eCOMS" height="40" />
      </a>
    </ng-template>
    <ng-template pTemplate="end">
      <a style="padding:0.5rem;" [routerLink]="'/alerts'">
        <fa-layers [fixedWidth]="false">
          <fa-icon [icon]="['fas', 'bell']" size="xl" style="color: white"></fa-icon>
          <fa-icon [icon]="['fas', 'circle']" style="color: var(--danger)" transform="shrink-1 right-11 up-6"></fa-icon>
          <fa-layers-text *ngIf="totalAlerts > 9" content="+9" style="color: white" transform="shrink-2 right-11 up-6"></fa-layers-text>
          <fa-layers-text *ngIf="totalAlerts <= 9" content="{{totalAlerts}}" style="color: white" transform="shrink-2 right-11 up-6"></fa-layers-text>
        </fa-layers>
      </a>
      <a style="padding:0.5rem;" [routerLink]="'/supervision-alerts'">
        <fa-layers [fixedWidth]="false">
          <fa-icon [icon]="['fas', 'exclamation-triangle']" size="xl" style="color: white"></fa-icon>
          <fa-icon [icon]="['fas', 'circle']" style="color: var(--danger)" transform="shrink-1 right-11 up-6"></fa-icon>
          <fa-layers-text *ngIf="totalSupervisionAlerts > 9" content="+9" style="color: white" transform="shrink-2 right-11 up-6"></fa-layers-text>
          <fa-layers-text *ngIf="totalSupervisionAlerts <= 9" content="{{totalSupervisionAlerts}}" style="color: white" transform="shrink-2 right-11 up-6"></fa-layers-text>
        </fa-layers>
      </a>
    </ng-template>
  </p-menubar>

  <div class="fixed-top" [ngStyle]="{'top' : environmentSetting === 'UAT' ? '120px' : '70px'}">
    <app-eca-breadcrumb></app-eca-breadcrumb>
  </div>  
</div>
